<template>
  <div class="row">
    <div class="col-md-12 mt50">

      <div v-if="loading">
        <div class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>
      </div>

      <template v-else>

        <div v-if="error" class="frm-error">{{ error_message }}</div>

        <div v-if=" proyectos.length == 0 "><h5>{{ $t('No se han encontrado resultados') }}</h5></div>

        <template v-if="proyectos">
          <div  v-for=" (item, index) in proyectos " class="proyecto mb100" :key="index">
            <h4 class="title">{{ item.proyecto }}</h4>
            <div class="row">
              <div class="col-md-2 col-md-offset-1 center completed">
                <h4>{{ $t('Asignado') }}</h4>
                <div :class="'c100 p100 center'">
                  <span>100%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br> 
                <p class="center ft-md">{{ toCurrency(item.asignado) }}</p>           
              </div>
              <div class="col-md-2 col-md-offset-2 center">
                <h4>{{ $t('Recibido') }}</h4>
                <div :class="'c100 p'+ Math.round(item.porcentaje_recibido) +' center'">
                  <span>{{ Math.round(item.porcentaje_recibido) }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br>
                <p class="center ft-md">{{ toCurrency(item.recibido) }}</p>  
              </div>
              <div class="col-md-2 col-md-offset-2 center">
                <h4>{{ $t('Diferencia') }}</h4>
                <div :class="' c100 p'+ Math.round(item.porcentaje_diferencia) +' center'">
                  <span>{{ Math.round(item.porcentaje_diferencia) }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br>   
                <p class="center ft-md">{{ toCurrency(item.diferencia) }}</p>  
              </div>
            </div>

            <table v-if=" item.referencia.length > 0 " class="table table-hover mt50 stats">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ $t('Referencia') }}</th>  
                  <th v-if=" getUserRole == 'admin' " class="center" width="120">{{ $t('Sustituciones') }}</th>                
                  <th class="center">{{ $t('Pendientes') }}</th>
                  <th class="center">{{ $t('En Proceso') }}</th>
                  <th class="center">{{ $t('Incidencias') }}</th>
                  <th class="center">{{ $t('Albaranados') }}</th>
                  <th class="center">{{ $t('Total') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tfoot v-if=" item.referencia.length > 1 ">
                <tr>
                  <td></td>
                  <th><router-link :to=" { name: 'consultas-pedido-referencia', params: { idConsorcio: item.id_consorcio } } ">{{ $t('Todos') }}</router-link></th>                
                  <td v-if=" getUserRole == 'admin' "></td>
                  <td>
                    <div class="data">{{ item.total_pendientes }} - {{ item.total_pendientes_porcentaje }}%</div>
                    <div :class=" (item.total_pendientes_porcentaje >= 100) ? 'progress completed' : 'progress' ">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="item.total_pendientes_porcentaje"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + item.total_pendientes_porcentaje + '%'">
                      </div>                    
                    </div>
                  </td>
                  <td>
                    <div class="data">{{ item.total_enproceso }} - {{ item.total_enproceso_porcentaje }}%</div>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="item.total_enproceso_porcentaje"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + item.total_enproceso_porcentaje + '%'">
                      </div>                    
                    </div>
                  </td>
                  <td>
                    <div class="data">{{ item.total_incidencias }} - {{ item.total_incidencias_porcentaje }}%</div>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="item.total_incidencias_porcentaje"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + item.total_incidencias_porcentaje + '%'">
                      </div>                    
                    </div>
                  </td>
                  <td>
                    <div class="data">{{ item.total_albaranados }} - {{ item.total_albaranados_porcentaje }}%</div>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="item.total_albaranados_porcentaje"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + item.total_albaranados_porcentaje + '%'">
                      </div>                    
                    </div>
                  </td>
                  <td class="center">{{ item.total_total }}</td>
                  <td class="center">
                    <router-link :to=" { name: 'consultas-pedido-referencia', params: { idConsorcio: item.id_consorcio } } ">
                      <i class="fa fa-eye"></i>
                    </router-link>
                  </td>
                </tr>
              </tfoot>
              <tbody>
                <tr v-for=" (referencia, index) in item.referencia " :key="index">
                  <th class="middle">{{ index + 1 }}</th>
                  <td>
                    <router-link :to=" { name: 'consultas-pedido-referencia', params: { idConsorcio: item.id_consorcio, referencia: referencia.referencia } } ">
                      {{ referencia.referencia }}
                    </router-link>
                  </td> 
                  <td v-if=" getUserRole == 'admin' " class="text-center">
                    <div v-if=" referencia.sustituciones == null "><img src="@/assets/img/loading-mini.gif" ></div>
                    <a v-else @click.prevent="toogleChecked(item.id_consorcio, referencia)" href="#" class="cine-ckeckbox pt5">
                      <i v-if=" parseInt(referencia.sustituciones) " class="fa fa-check-square-o"></i>
                      <i v-else class="fa fa-square-o"></i>
                    </a>
                  </td>               
                  <td>
                    <div class="data">{{ referencia.pendientes }} - {{ Math.round(referencia.porcentaje_pendientes) }}%</div>
                    <div :class=" (referencia.porcentaje_pendientes >= 100) ? 'progress completed' : 'progress' ">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="Math.round(referencia.porcentaje_pendientes)"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + Math.round(referencia.porcentaje_pendientes) + '%'">
                      </div>                    
                    </div>
                  </td>
                  <td>
                    <div class="data">{{ referencia.enproceso }} - {{ Math.round(referencia.porcentaje_enproceso) }}%</div>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="Math.round(referencia.porcentaje_enproceso)"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + Math.round(referencia.porcentaje_enproceso) + '%'">
                      </div>                    
                    </div>
                  </td>
                  <td>
                    <div class="data">{{ referencia.incidencias }} - {{ Math.round(referencia.porcentaje_incidencias) }}%</div>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="Math.round(referencia.porcentaje_incidencias)"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + Math.round(referencia.porcentaje_incidencias) + '%'">
                      </div>
                      
                    </div>
                  </td>
                  <td>
                    <div class="data">{{ referencia.albaranados }} - {{ Math.round(referencia.porcentaje_albaranados) }}%</div>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" :aria-valuenow="Math.round(referencia.porcentaje_albaranados)"
                        aria-valuemin="0" aria-valuemax="100" :style="'width:' + Math.round(referencia.porcentaje_albaranados) + '%'">
                      </div>                    
                    </div>
                  </td>
                  <td class="center"><strong>{{ referencia.total }}</strong></td>
                  <td class="center">
                    <router-link :to=" { name: 'consultas-pedido-referencia', params: { idConsorcio: item.id_consorcio, referencia: referencia.referencia } } ">
                      <i class="fa fa-eye"></i>
                    </router-link>
                  </td>
                </tr>
              </tbody>            
            </table> 
          </div>
        </template>        
      </template>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Por pedido": "Por pedido",
    "Proyecto": "Proyecto",
    "Fecha": "Fecha",
    "Artículo": "Artículo",
    "Cantidad": "Cantidad",
    "Referencia": "Referencia",
    "CDU": "CDU",
    "Situación": "Situación",
    "Todos": "Todos",
    "Pendiente": "Pendiente",
    "En Tatarana": "En Tatarana",
    "Incidencia": "Incidencia",
    "Facturado": "Facturado",
    "Tiene que seleccionar un proyecto": "Tiene que seleccionar un proyecto",
    "Vaciar": "Vaciar",
    "Buscar": "Buscar",
    "Tiene que seleccionar una referencia": "Tiene que seleccionar una referencia",
    "Total": "Total",
    "Guardar": "Guardar",
    "Vaciar": "Vaciar",
    "Ejemplares": "Ejemplares",
    "Total ejemplares": "Total ejemplares",
    "Importe": "Importe",
    "Por proyecto": "Por proyecto",
    "Proyecto": "Proyecto",
    "Asignado": "Asignado",
    "Recibido": "Recibido",
    "Diferencia": "Diferencia",
    "Proyecto": "Proyecto",
    "No se han encontrado resultados": "No se han encontrado resultados",
    "Código": "Código",
    "Pendientes": "Pendientes",
    "En Proceso": "En Proceso",
    "Incidencias": "Incidencias",
    "Albaranados": "Albaranados",
    "Sustituciones": "Sustituciones"
  },
  "en": {
  },
  "ca": {
    "Por pedido": "Per comanda",
    "Proyecto": "Projecte",
    "Fecha": "Data",
    "Artículo": "Article",
    "Cantidad": "Quantitat",
    "Referencia": "Referència",
    "CDU": "CDU",
    "Situación": "Situació",
    "Todos": "Tots",
    "Pendiente": "Pendent",
    "En Tatarana": "A Tatarana",
    "Incidencia": "Incidència",
    "Facturado": "Facturat",
    "Tiene que seleccionar un proyecto": "Ha de seleccionar un projecte",
    "Vaciar": "Vaciar",
    "Buscar": "Buscar",
    "Tiene que seleccionar una referencia": "Ha de seleccionar una referència",
    "Total": "Total",
    "Guardar": "Guardar",
    "Vaciar": "Buidar",
    "Ejemplares": "Exemplars",
    "Total ejemplares": "Total exemplars",
    "Importe": "Import",
    "Por proyecto": "Per projecte",
    "Proyecto": "Projecte",
    "Asignado": "Assignat",
    "Recibido": "Rebut",
    "Diferencia": "Diferència",
    "No se han encontrado resultados": "No s'han trobat resultats",
    "Pendientes": "Pendents",
    "En Proceso": "En Procés",
    "Incidencias": "Incidencies",
    "Albaranados": "Albaranats",
    "Sustituciones": "Substitucions"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

  export default {
    data: () => {
      return{
        proyectos: '',
        error: false,
        error_message: '',
        loading: false,
        totales: [],
      }
    },
    created(){
      this.loadProyectos();
    },
    mounted(){
      
    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl', 'getUserRole', 'getActiveBiblioteca']),
    },
    methods: {
      loadProyectos() {
        this.showLoading();        
        
        // INICIO CONSORCIOS
        // Para cpanel se necesita la referencia de la biblioteca
        // Si el consorcio inicia sesión y consulta mis pedidos no se necesita la referencia
        var suffix;
        if(this.getUserRole == 'badmin'){
          if (this.$route.path.search('cpanel') != -1) {
            suffix = '?bibl=' + this.getActiveBiblioteca;
          }else{
            suffix = ''
          }
        }else{
          suffix = ''
        }
        //console.log(this.$route.path);
        // FIN CONSORCIOS

        axios.get( this.getApiUrl + this.getLocale + '/misconsultas/proyecto' + suffix, { 
        })
          .then( (respuesta) =>{ 
            this.proyectos = respuesta.data.data.proyectos;
            this.calcularTotales();
            this.hideLoading();
          })
        .catch( (error) =>{ 
          this.hideLoading();
          this.error_message = error.response.data.msg;
          this.error = true;
        });
      },  
      calcularTotales(){
        for(var i=0; i < this.proyectos.length; i++ ){
          //console.log( this.proyectos[i]);
          if( this.proyectos[i].referencia.length > 1 ){
            //console.log( this.proyectos[i].referencia);
            this.proyectos[i]["total_total"] = this.proyectos[i].referencia.reduce( (total, referencia) => total + parseInt(referencia.total), 0);

            this.proyectos[i]["total_albaranados"] = this.proyectos[i].referencia.reduce( (total, referencia) => total + parseInt(referencia.albaranados), 0);
            this.proyectos[i]["total_albaranados_porcentaje"] = Math.round( (this.proyectos[i]["total_albaranados"] / this.proyectos[i]["total_total"]) * 100 );

            this.proyectos[i]["total_enproceso"] = this.proyectos[i].referencia.reduce( (total, referencia) => total + parseInt(referencia.enproceso), 0);
            this.proyectos[i]["total_enproceso_porcentaje"] = Math.round( (this.proyectos[i]["total_enproceso"] / this.proyectos[i]["total_total"]) * 100 );
            
            this.proyectos[i]["total_pendientes"] = this.proyectos[i].referencia.reduce( (total, referencia) => total + parseInt(referencia.pendientes), 0);
            this.proyectos[i]["total_pendientes_porcentaje"] = Math.round( (this.proyectos[i]["total_pendientes"] / this.proyectos[i]["total_total"]) * 100 );

            this.proyectos[i]["total_incidencias"] = this.proyectos[i].referencia.reduce( (total, referencia) => total + parseInt(referencia.incidencias), 0);
            this.proyectos[i]["total_incidencias_porcentaje"] = Math.round( (this.proyectos[i]["total_incidencias"] / this.proyectos[i]["total_total"]) * 100 );

          } 
        }        
      },  
      toogleChecked(idConsorcio, referencia){
        let value = parseInt(referencia.sustituciones) ? 0 : 1

        this.$set(referencia, 'sustituciones', null)

        /* setTimeout(() => {
          this.$set(referencia, 'sustituciones', value)
        }, 500); */

        axios.post( this.getApiUrl + this.getLocale + '/misconsultas/sustituciones/activar', { 
          id_consorcio: idConsorcio,
          referencia: referencia.referencia,
          activo: value
        })
          .then( (respuesta) =>{ 
            this.$set(referencia, 'sustituciones', value)
            this.hideLoading();
          })
        .catch( (error) =>{ 
          this.$set(referencia, 'sustituciones', !value)
          this.hideLoading();
          this.error_message = error.response.data.msg;
          this.error = true;
        });
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch: {
      '$route.params.bibl': function (id) {
        this.loadProyectos()
      }
    }
  }
</script>
